(function () {
  'use strict';

  var PASSUNG_TYPEN = ['ADAPTER', 'PLATE'];
  var WAHL_KEY = '3idee_auswahl';

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }
  function lies(sel) {
    var el = document.querySelector(sel);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function auswahl() {
    try {
      var a = JSON.parse(localStorage.getItem(WAHL_KEY) || 'null');
      if (a && a.refs && a.refs.length) {
        var namen = a.namen || [], gesehen = {}, monitore = [];
        a.refs.forEach(function (ref, i) {
          var k = String(ref);
          if (gesehen[k]) { gesehen[k].anzahl++; return; }
          gesehen[k] = { ref: k, name: namen[i] || (i === 0 ? a.name : '') || a.name || '', anzahl: 1 };
          monitore.push(gesehen[k]);
        });
        return { refs: a.refs.map(String), name: a.name || namen[0] || '', monitore: monitore };
      }
    } catch (e) {}
    return null;
  }
  function merke(ref, name) {
    try {
      var alt = null;
      try { alt = JSON.parse(localStorage.getItem(WAHL_KEY) || 'null'); } catch (e) {}
      localStorage.setItem(WAHL_KEY, JSON.stringify({
        refs: [ref], name: name, namen: [name], anzahl: 1,
        mount: (alt && alt.mount) || '', tisch: (alt && alt.tisch) || null,
        pfad: location.pathname, zeit: Date.now()
      }));
      document.dispatchEvent(new CustomEvent('finder:auswahl'));
    } catch (e) {}
  }

  var aktuell = null;
  function start() {
  var box = document.querySelector('[data-akl-pruef]');
  if (!box) return;

  var DATEN = lies('[data-akl-daten]');
  var HIER = lies('[data-akl-hier]');
  var proxy = (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db';
  var finderUrl = box.getAttribute('data-finder') || '/pages/setup-finder';
  var kollName = box.getAttribute('data-kollektion') || '';
  var istAlle = box.getAttribute('data-ist-alle') === 'true';

  var frageEl = box.querySelector('[data-akl-frage]');
  var frageText = frageEl ? frageEl.innerHTML : '';

  var T = {};
  try { T = JSON.parse((box.querySelector('[data-akl-texte]') || {}).textContent || '{}'); } catch (e) {}
  function t(k, werte) {
    var s = T[k] || '';
    Object.keys(werte || {}).forEach(function (w) { s = s.split('{' + w + '}').join(werte[w]); });
    return s;
  }
  var fussEl = box.querySelector('[data-akl-fuss]');
  var wahl = box.querySelector('[data-akl-wahl]');
  var neuEl = box.querySelector('[data-akl-neu]');
  var nameEl = box.querySelector('[data-akl-name]');
  var eingabe = box.querySelector('[data-akl-eingabe]');
  var input = box.querySelector('[data-akl-input]');
  var form = box.querySelector('[data-akl-form]');
  var treffer = box.querySelector('[data-akl-treffer]');
  var erg = box.querySelector('[data-akl-erg]');
  var zeilen = box.querySelector('[data-akl-zeilen]');
  var vf = box.querySelector('[data-akl-vf]');

  var h1 = document.querySelector('main h1, h1');
  if (h1 && !h1.hasAttribute('data-akl-ur')) h1.setAttribute('data-akl-ur', h1.textContent.trim());
  var h1Text = h1 ? h1.getAttribute('data-akl-ur') : '';

  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }

  var MONITOR_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
    + 'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<rect x="3" y="4" width="18" height="12" rx="2"></rect><path d="M8 20h8M12 16v4"></path></svg>';
  var ZEICHEN = { ok: '✓', warn: '✕', neutral: '–' };
  var vfHeim = vf ? vf.parentNode : null;

  function handleAus(url) {
    var m = /\/products\/([^/?#]+)/.exec(url || '');
    return m ? m[1] : '';
  }
  function zeile(name, wort, stufe) {
    return '<div class="fck__z-zeile" data-fck-z><span class="fck__z-modell">' + MONITOR_SVG + esc(name) + '</span>'
      + '<span class="fck__z-linie" aria-hidden="true"></span>'
      + '<span class="fck__z-status fck__z-status--' + stufe + '">'
      + (ZEICHEN[stufe] ? '<i aria-hidden="true">' + ZEICHEN[stufe] + '</i>' : '') + esc(wort) + '</span></div>';
  }
  function mini(p) {
    var handle = handleAus(p.url);
    var bild = '<span class="fck__vorschlag-ic" data-mini-bild>'
      + (p.bild ? '<img src="' + esc(p.bild) + '" alt="" loading="lazy">' : '') + '</span>';
    return '<div class="fck__mini"' + (handle ? ' data-mini-handle="' + esc(handle) + '"' : '') + '>'
      + '<button class="fck__mini-bild" type="button" data-mini-auf aria-label="' + esc(p.titel) + '" tabindex="-1">' + bild + '</button>'
      + '<div class="fck__mini-txt"><span class="fck__mini-titel" data-mini-titel>' + esc(p.titel) + '</span>'
      + '<span class="fck__mini-preis" data-mini-preis>' + esc(p.preis || '') + '</span></div>'
      + '</div>';
  }
  function karten(kopf, liste, anzahl) {
    var html = liste.map(mini).join('');
    if (anzahl > 1) html = html.replace(/<div class="fck__mini" data-mini-handle=/g, '<div class="fck__mini" data-mini-anzahl="' + anzahl + '" data-mini-handle=');
    return '<div class="fck__z-anhang"><div class="fck__karten">'
      + (kopf ? '<span class="fck__karten-kopf">' + esc(kopf) + '</span>' : '')
      + html + '</div></div>';
  }
  function kurz(text) {
    return text ? '<div class="fck__z-anhang"><small class="fck__z-kurz">' + esc(text) + '</small></div>' : '';
  }
  function setzeZeilen(html) {
    if (vf && vfHeim && vf.parentNode !== vfHeim) vfHeim.appendChild(vf);
    if (vf) { vf.classList.remove('fck__vf--inline'); vf.hidden = true; }
    zeilen.innerHTML = html;
  }
  function verified() {
    var z = zeilen.querySelector('[data-fck-z]');
    if (!vf || !z) return;
    z.appendChild(vf);
    vf.classList.add('fck__vf--inline');
    vf.hidden = false;
  }

  var abschnitte = {};
  var WURZEL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function abschnittHolen(handle) {
    if (abschnitte[handle]) return abschnitte[handle];
    abschnitte[handle] = fetch(WURZEL + 'products/' + handle + '?section_id=mini-produktseite')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var raum = document.createElement('div');
        raum.innerHTML = html;
        var roh = raum.querySelector('[data-mpd-daten]');
        var daten = null;
        try { daten = JSON.parse(roh ? roh.textContent : 'null'); } catch (e) {}
        return { html: html, daten: daten };
      });
    return abschnitte[handle];
  }
  function angebotNachladen(wurzel) {
    wurzel.querySelectorAll('[data-mini-handle]').forEach(function (karte) {
      if (karte.__mini) return;
      karte.__mini = true;
      abschnittHolen(karte.getAttribute('data-mini-handle')).then(function (a) {
        var raum = document.createElement('div');
        raum.innerHTML = a.html;
        var titelEl = karte.querySelector('[data-mini-titel]');
        if (titelEl && !titelEl.querySelector('button')) titelEl.innerHTML = '<button class="fck__mini-titel-knopf" type="button" data-mini-auf>' + esc(titelEl.textContent) + '</button>';
        var d = a.daten;
        if (!d) return;
        var bildEl = karte.querySelector('[data-mini-bild]');
        if (bildEl && !bildEl.firstElementChild && d.bild) bildEl.innerHTML = '<img src="' + esc(d.bild) + '" alt="" loading="lazy">';
        var anzahl = Number(karte.getAttribute('data-mini-anzahl')) || 1;
        var preisEl = karte.querySelector('[data-mini-preis]');
        if (preisEl && d.preis) preisEl.innerHTML = d.preis + (anzahl > 1 ? '<small>' + esc(t('pro_stueck') || '/ Stück') + '</small>' : '');
        var aktion = karte.querySelector('[data-mini-aktion]');
        if (!aktion) return;
        var kaufbar = (d.varianten || []).filter(function (v) { return v.kaufbar; });
        var vorlage = raum.querySelector('[data-mpd-kartenform]');
        var mpd = raum.querySelector('.mpd');
        function wort(name, ersatz) { return (mpd && mpd.getAttribute('data-mpd-text-' + name)) || ersatz; }
        if (!kaufbar.length) {
          aktion.innerHTML = '<button class="fck__mini-ersatz" type="button" disabled>' + esc(wort('weg', t('nicht_verfuegbar') || 'Nicht verfügbar')) + '</button>';
        } else if (!vorlage || !vorlage.content) {
          aktion.innerHTML = '<button class="fck__mini-ersatz" type="button" data-mini-auf>' + esc(wort('wahl', t('auswaehlen') || 'Auswählen')) + '</button>';
        } else {
          var knoten = document.importNode(vorlage.content, true);
          if (anzahl > 1) {
            var mengenfeld = knoten.querySelector('input[name="quantity"]');
            if (mengenfeld) mengenfeld.value = anzahl;
            var kaufform = knoten.querySelector('product-form-component');
            if (kaufform) kaufform.setAttribute('data-quantity-default', anzahl);
          }
          var wahlK = knoten.querySelector('.quick-add__button--choose');
          if (wahlK) { wahlK.removeAttribute('on:click'); wahlK.setAttribute('data-mini-auf', ''); }
          aktion.appendChild(knoten);
          aktion.classList.add('fck__mini-aktion--quick');
        }
      }).catch(function () {});
    });
  }
  box.addEventListener('click', function (e) {
    var auf = e.target.closest && e.target.closest('[data-mini-auf]');
    var karte = auf && auf.closest('[data-mini-handle]');
    if (karte) { e.preventDefault(); location.href = WURZEL + 'products/' + karte.getAttribute('data-mini-handle'); }
  });

  function weitere(an) {
    var grid = document.querySelector('[data-akl] .product-grid');
    if (!grid) return;
    var alt = grid.querySelector('.akl-weitere');
    if (!an) { if (alt) alt.remove(); return; }
    if (alt) return;
    var li = document.createElement('li');
    li.className = 'product-grid__item akl-weitere';
    var weiterWort = istAlle ? t('weitere_adapter') : t('weitere_von', { titel: h1Text });
    li.innerHTML = '<h2 class="akl-weitere__titel">' + esc(weiterWort) + '</h2>';
    grid.insertBefore(li, grid.firstChild);
  }

  var imKopf = [];
  function raster() {
    document.querySelectorAll('[data-akl] .product-grid__item[data-product-id]').forEach(function (li) {
      li.classList.toggle('akl-im-kopf', imKopf.indexOf(Number(li.getAttribute('data-product-id'))) > -1);
    });
    var grid = document.querySelector('[data-akl] .product-grid');
    if (!grid || grid.hasAttribute('data-akl-stand')) return;
    var sichtbar = Array.prototype.filter.call(grid.querySelectorAll('.product-grid__item[data-product-id]'), function (li) {
      return !li.classList.contains('akl-im-kopf') && (li.getAttribute('data-page') || '1') === '1';
    });
    grid.setAttribute('data-akl-stand', '1');
    if (!sichtbar.length) return;
    var vorlagen = Array.prototype.slice.call(document.querySelectorAll('template[data-akl-karte]'))
      .sort(function (a, b) { return Number(b.getAttribute('data-akl-karte')) - Number(a.getAttribute('data-akl-karte')); });
    vorlagen.forEach(function (t) {
      var nach = Number(t.getAttribute('data-akl-karte')) || 6;
      if (nach > sichtbar.length - 3) return;
      var ziel = sichtbar[nach - 1];
      if (!ziel) return;
      var li = document.createElement('li');
      li.className = 'product-grid__item akl-karte-platz' + (t.getAttribute('data-akl-breit') === 'true' ? ' akl-karte-platz--breit' : '');
      li.appendChild(t.content.cloneNode(true));
      ziel.after(li);
    });
  }

  function zeigeSuche(mitMonitor) {
    if (frageEl) frageEl.innerHTML = frageText;
    if (fussEl) fussEl.style.display = '';
    wahl.hidden = !mitMonitor;
    if (neuEl) neuEl.hidden = true;
    eingabe.hidden = false;
    erg.hidden = true;
    setzeZeilen('');
    weitere(false);
  }

  function ueberschrift(a) {
    if (!h1) return;
    h1.textContent = h1Text;
  }

  function finderWeg() {
    var ziel = finderUrl + (finderUrl.indexOf('?') > -1 ? '&' : '?') + 'finder=neu&setup=1';
    return '<div class="fck__z-anhang"><a class="fck__zweitweg" href="' + esc(ziel) + '">' + esc(t('absage')) + '</a></div>';
  }
  function engineFrage(m) {
    return abruf(proxy + '/monitors/' + encodeURIComponent(m.ref) + '/compatibility')
      .then(function (json) {
        var recs = (json && json.ok && json.data && json.data.recommendations) || [];
        var teile = [], gesehen = {};
        recs.forEach(function (r) {
          if (r.requirement !== 'REQUIRED') return;
          (r.products || []).forEach(function (p) {
            if (PASSUNG_TYPEN.indexOf(p.type) < 0 || p.in_shop === false || !p.url) return;
            var k = p.shopify_sku || p.sku;
            if (gesehen[k]) return;
            gesehen[k] = true;
            teile.push({ url: p.url, titel: p.name || p.sku, preis: '', bild: p.image_url && p.image_url.indexOf('/media/') === 0 ? proxy + p.image_url : (p.image_url || '') });
          });
        });
        if (teile.length) return { m: m, teile: teile };
        var noetig = recs.some(function (r) {
          if (r.offer_contact) return true;
          if (r.requirement !== 'REQUIRED') return false;
          var ps = r.products || [];
          return !ps.length || ps.some(function (p) { return PASSUNG_TYPEN.indexOf(p.type) > -1; });
        });
        return { m: m, zustand: noetig ? 'kein' : 'frei' };
      })
      .catch(function () { return { m: m, zustand: 'aus' }; });
  }

  var korb = box.querySelector('[data-akl-korb]');
  var korbKnopf = korb ? korb.querySelector('button') : null;
  var korbPosten = [];
  function korbText(stueck) {
    var el = korbKnopf && korbKnopf.querySelector('.add-to-cart-text__content span span');
    if (!el) return;
    el.textContent = stueck > 1
      ? (korb.getAttribute('data-korb-wort') || '%d').replace('%d', stueck)
      : (korb.getAttribute('data-korb-eins') || el.textContent);
  }
  function korbSetzen(teile) {
    if (!korb || !korbKnopf) return;
    korbPosten = [];
    if (!teile.length) { korb.hidden = true; return; }
    korb.hidden = false;
    korbKnopf.disabled = true;
    korbText(teile.reduce(function (n, x) { return n + x.anzahl; }, 0));
    var stand = teile.map(function (x) { return x.url; }).join('|');
    korb.setAttribute('data-stand', stand);
    Promise.all(teile.map(function (x) {
      return abschnittHolen(handleAus(x.url)).then(function (a) {
        var d = a.daten || {};
        var v = (d.varianten || []).filter(function (y) { return y.kaufbar; })[0];
        return v ? { id: v.id, quantity: x.anzahl, bild: d.bild || '' } : null;
      }).catch(function () { return null; });
    })).then(function (liste) {
      if (korb.getAttribute('data-stand') !== stand) return;
      korbPosten = liste.filter(Boolean);
      var stueck = korbPosten.reduce(function (n, x) { return n + x.quantity; }, 0);
      korbText(stueck);
      korbKnopf.disabled = !stueck;
      var komp = korbKnopf.closest('add-to-cart-component');
      if (komp && korbPosten[0] && korbPosten[0].bild) komp.setAttribute('data-product-variant-media', korbPosten[0].bild);
    });
  }
  if (korbKnopf) {
    korbKnopf.addEventListener('click', function (e) {
      e.preventDefault();
      if (!korbPosten.length || !window.WarenkorbLegen) return;
      korbKnopf.disabled = true;
      window.WarenkorbLegen(korbPosten.map(function (x) { return { id: x.id, quantity: x.quantity }; }), function () {
        korbKnopf.disabled = false;
      });
    });
  }

  function zeichne(liste, a) {
    imKopf = [];
    var html = '', einOk = false, teile = [];
    liste.forEach(function (e) {
      var name = (e.m.anzahl > 1 ? e.m.anzahl + '× ' : '') + e.m.name;
      if (e.passend || e.teile) {
        var hier = (e.passend || []).filter(function (p) { return HIER.indexOf(p.id) > -1; });
        var dort = (e.passend || []).filter(function (p) { return HIER.indexOf(p.id) < 0; });
        var zeig = e.teile || (hier.length ? hier : dort);
        var kopf = t('passender_adapter');
        hier.forEach(function (p) { if (imKopf.indexOf(p.id) < 0) imKopf.push(p.id); });
        var karte = zeig.slice(0, 1).map(function (p) {
          var k = {}; for (var x in p) k[x] = p[x];
          k.titel = t('adapter_fuer', { name: e.m.name });
          return k;
        });
        html += zeile(name, t('gefunden'), 'ok') + karten('', karte, e.m.anzahl);
        teile.push({ url: zeig[0].url, bild: zeig[0].bild, monitor: e.m.name, anzahl: e.m.anzahl });
        einOk = true;
      } else if (e.zustand === 'kein') {
        html += zeile(name, t('kein_passender'), 'neutral') + finderWeg();
      } else if (e.zustand === 'frei') {
        html += zeile(name, t('kein_adapter_noetig'), 'neutral');
      } else if (e.zustand === 'aus') {
        html += zeile(name, t('nicht_erreichbar'), 'neutral');
      } else {
        html += zeile(name, t('wird_geprueft'), 'neutral');
      }
    });
    setzeZeilen(html);
    if (einOk) {
      if (liste.length === 1) verified();
      else if (vf) {
        vf.hidden = false;
      }
    }
    var mehrere = liste.length > 1;
    if (frageEl) {
      frageEl.textContent = !einOk ? t(mehrere ? 'deine_monitore' : 'dein_monitor')
        : t(mehrere ? 'passt_mehrere' : 'passt');
    }
    erg.hidden = false;
    angebotNachladen(zeilen);
    korbSetzen(teile);
    raster();
    weitere(einOk);
  }

  function antwort() {
    var a = auswahl();
    imKopf = [];
    if (!a) { ueberschrift(null); zeigeSuche(false); raster(); return; }

    nameEl.textContent = a.name;
    wahl.hidden = true;
    if (neuEl) neuEl.hidden = false;
    eingabe.hidden = true;
    if (fussEl) fussEl.style.display = 'none';
    ueberschrift(a);

    var liste = a.monitore.map(function (m) {
      var passend = DATEN.filter(function (p) { return p.refs.some(function (r) { return String(r) === m.ref; }); });
      return passend.length ? { m: m, passend: passend } : { m: m, offen: true };
    });
    zeichne(liste, a);
    var offen = liste.filter(function (e) { return e.offen || e.passend; });
    if (!offen.length) return;
    var stand = JSON.stringify(a.refs);
    Promise.all(offen.map(function (e) { return engineFrage(e.m); })).then(function (antworten) {
      var jetzt = auswahl();
      if (!jetzt || JSON.stringify(jetzt.refs) !== stand) return;
      antworten.forEach(function (r) {
        var i = liste.findIndex(function (e) { return e.m.ref === r.m.ref; });
        if (i < 0) return;
        if (liste[i].passend) {
          if (r.zustand === 'frei') liste[i] = r;
          return;
        }
        liste[i] = r;
      });
      zeichne(liste, a);
    });
  }

  if (window.matchMedia && window.matchMedia('(max-width: 1023px)').matches && input.getAttribute('data-kurz')) {
    input.placeholder = input.getAttribute('data-kurz');
  }
  if (window.Suchebene && form && input && treffer) {
    window.Suchebene.binden({
      leiste: form,
      eingabe: input,
      liste: treffer,
      zu: function () { treffer.hidden = true; treffer.innerHTML = ''; },
      titel: (frageEl && frageEl.textContent.trim()) || ''
    });
  }
  function nachmessen() { if (window.Suchebene && window.Suchebene.messen) { try { window.Suchebene.messen(); } catch (e) {} } }
  var uhr = null, letzte = '', erster = null;
  function suche(q) {
    abruf(proxy + '/monitors/search?q=' + encodeURIComponent(q))
      .then(function (json) {
        if (q !== letzte) return;
        var data = (json && json.data) || {};
        var liste = (data.found && data.results && data.results.length) ? data.results : (data.similar || []);
        erster = liste[0] || null;
        if (!json || !json.ok || !liste.length) { treffer.innerHTML = '<b>' + esc(t('kein_treffer')) + '</b>'; treffer.hidden = false; nachmessen(); return; }
        treffer.innerHTML = '<b>' + esc(t('meintest_du')) + '</b>' + liste.map(function (m) {
          var zus = [];
          if (m.size_inch) zus.push(String(parseFloat(m.size_inch)).replace('.', ',') + '"');
          if (m.year) zus.push(m.year);
          return '<button type="button" data-ref="' + esc(m.ref) + '" data-name="' + esc(m.name) + '">' + esc(m.name)
            + (zus.length ? ' <small>· ' + esc(zus.join(' · ')) + '</small>' : '') + '</button>';
        }).join('');
        treffer.hidden = false;
        nachmessen();
      })
      .catch(function (e) {
        if (q !== letzte) return;
        if (e && e.engineAus && window.EngineStatus && window.EngineStatus.hinweisHtml) {
          treffer.innerHTML = window.EngineStatus.hinweisHtml(t('suche_aus'), t('wa_nachricht') + ' ');
          treffer.hidden = false;
        } else { treffer.hidden = true; }
      });
  }
  input.addEventListener('input', function () {
    var q = input.value.trim(); letzte = q; erster = null; clearTimeout(uhr);
    if (q.length < 2) { treffer.hidden = true; return; }
    uhr = setTimeout(function () { suche(q); }, 180);
  });
  treffer.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-ref]'); if (!b) return;
    treffer.hidden = true; input.value = '';
    merke(b.getAttribute('data-ref'), b.getAttribute('data-name'));
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (erster) { treffer.hidden = true; input.value = ''; merke(String(erster.ref), erster.name); }
    else if (input.value.trim().length >= 2) { letzte = input.value.trim(); suche(letzte); }
  });
  box.querySelector('[data-akl-aendern]').addEventListener('click', function () {
    zeigeSuche(true); input.focus();
  });

  aktuell = {
    antwort: antwort,
    abgleich: function () {
      document.querySelectorAll('[data-akl] .product-grid__item[data-product-id]').forEach(function (li) {
        li.classList.toggle('akl-im-kopf', imKopf.indexOf(Number(li.getAttribute('data-product-id'))) > -1);
      });
    }
  };
  antwort();
  box.setAttribute('data-akl-stand', '1');
  }

  document.addEventListener('finder:auswahl', function () { if (aktuell) aktuell.antwort(); });
  window.addEventListener('storage', function (e) { if (e.key === WAHL_KEY && aktuell) aktuell.antwort(); });

  start();

  var abschnitt = document.querySelector('[data-akl]');
  abschnitt = abschnitt && (abschnitt.closest('.shopify-section') || abschnitt.parentNode);
  if (abschnitt && window.MutationObserver) {
    var uhrW = null;
    new MutationObserver(function () {
      clearTimeout(uhrW);
      uhrW = setTimeout(function () {
        var b = document.querySelector('[data-akl-pruef]');
        var g = document.querySelector('[data-akl] .product-grid');
        if ((b && !b.hasAttribute('data-akl-stand')) || (g && !g.hasAttribute('data-akl-stand'))) { start(); return; }
        if (aktuell) aktuell.abgleich();
      }, 120);
    }).observe(abschnitt, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-akl-stand'] });
  }
})();
